var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLaw105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M32 92h41v1H32v-1Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M53 20v-8h-1v8H28.243L8 48.34v.16C8 57.612 15.388 65 24.5 65S41 57.612 41 48.5v-.103L29.258 21H52v62h1V21h22.742L64 48.397v.103C64 57.612 71.388 65 80.5 65S97 57.612 97 48.5v-.16L76.757 20H53ZM39.742 48 28.39 21.514 9.472 48h30.27ZM9.008 49c.264 8.328 7.1 15 15.492 15 8.393 0 15.228-6.672 15.492-15H9.008Zm86.52-1L76.61 21.514 65.258 48h30.27Zm-30.52 1h30.984c-.264 8.328-7.1 15-15.492 15-8.393 0-15.228-6.672-15.492-15Z",
  clipRule: "evenodd"
})));
export { SvgLaw105 as ReactComponent };
export default __webpack_public_path__ + "1b81a7491f0b82d44ba6015326834b17.svg";